<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md8>
				<v-layout row wrap>
					<v-flex xs6 md12>
						<form-localized-input
							v-model="item.name"
							:label="$t('Name')"
						></form-localized-input>
					</v-flex>
					<v-flex xs6 md12>
						<v-text-field
							label="SKU"
							type="text"
							v-model="item.sku"
							data-vv-name="sku"
							dense
						></v-text-field>
					</v-flex>
					<v-flex xs6 md12>
						<v-autocomplete
							:label="$t('Parent')"
							v-model="item.parent_id"
							:items="parents"
							item-value="id"
							item-text="name"
							data-vv-name="parent_id"
							dense
							clearable
						></v-autocomplete>
					</v-flex>
					<v-flex xs6 md6>
						<v-select
							:label="$t('Category')"
							v-model="item.category_id"
							:items="categories"
							item-value="id"
							item-text="name"
							data-vv-name="category_id"
							dense
							class="required"
							clearable
							@change="onCategoryChanged"
						></v-select>
					</v-flex>
					<v-flex xs6 md6>
						<v-select
							:label="$t('Subcategory')"
							v-model="item.subcategory_id"
							:items="subcategories"
							item-value="id"
							item-text="name"
							data-vv-name="subcategory_id"
							dense
							clearable
						></v-select>
					</v-flex>
					<v-flex xs6 md6>
						<v-select
							:label="$t('label.unit')"
							v-model="item.unit_id"
							:items="units"
							item-value="id"
							item-text="name"
							data-vv-name="unit_id"
							dense
							clearable
						></v-select>
					</v-flex>
					<v-flex xs12 md6>
						<v-select
							:label="$t('label.tax')"
							v-model="item.tax_id"
							:items="taxes"
							item-value="id"
							item-text="name"
							data-vv-name="tax_id"
							dense
							clearable
						></v-select>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							type="number"
							v-model="item.minimum_quantity"
							:label="$t('Minimum Quantity')"
							dense
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							type="number"
							v-model="item.maximum_quantity"
							:label="$t('Maximum Quantity')"
							dense
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							type="number"
							v-model="item.daily_limit_quantity"
							:label="$t('Daily Limit Quantity')"
							dense
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							type="number"
							v-model="item.preparation_duration"
							:label="$t('Preparation Duration')"
							dense
							:hint="$t('In minutes')"
							persistent-hint
						>
						</v-text-field>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4 class="pl-10">
				<v-layout row wrap>
					<v-flex xs12>
						<v-card
							><v-system-bar color="grey darken-4" height="10">
							</v-system-bar>
							<v-card-title primary-title>
								{{ $t("label.image")
								}}<small><code>(4:3 Ratio)</code></small>
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<app-media-library
									v-model="item.image"
								></app-media-library>
							</v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12>
				<v-card>
					<v-system-bar color="grey darken-4" height="10">
					</v-system-bar>
					<v-card-title primary-title>
						{{ $t("Price") }} &
						{{ $t("label.attributes") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<v-btn-toggle
									v-model="item.type"
									tile
									color="deep-purple accent-3"
									group
								>
									<v-btn value="simple">
										Simple Product
									</v-btn>

									<v-btn value="variable">
										Variable Product
									</v-btn>
								</v-btn-toggle>
							</v-flex>
							<v-flex xs12 md12 v-if="item.type == 'simple'">
								<v-text-field
									:label="$t('Price')"
									type="number"
									v-model="item.price"
									data-vv-name="price"
									dense
									class="required"
									filled
								></v-text-field>
							</v-flex>
							<v-flex xs12 v-if="item.type == 'variable'">
								<shop-variation-form
									v-model="item.variations"
								></shop-variation-form>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs12>
				<v-card>
					<v-system-bar color="grey darken-4" height="10">
					</v-system-bar>
					<v-card-title primary-title>
						{{ $t("label.extras") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<shop-extra-form
							v-model="item.extras"
						></shop-extra-form>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs12>
				<ValidationProvider name="name" v-slot="{ errors, valid }">
					<form-localized-editor
						v-model="item.description"
						:errors="errors"
						:valid="valid"
					>
					</form-localized-editor>
				</ValidationProvider>
			</v-flex>

			<v-flex xs12>
				<v-card
					><v-system-bar color="grey darken-4" height="10">
					</v-system-bar>
					<v-card-title primary-title>
						{{ $t("Module Setting") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12 md4>
								<v-switch
									v-model="item.settings.delivery_module"
									:label="$t('Delivery Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md4>
								<v-switch
									v-model="item.settings.pickup_module"
									:label="$t('Pickup Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md4>
								<v-switch
									v-model="item.settings.dine_in_module"
									:label="$t('Dinein Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md4>
								<v-switch
									v-model="item.settings.is_free_flow"
									:label="$t('Is Free-flow')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md4>
								<v-switch
									v-model="item.settings.is_main_free_flow"
									:label="$t('Is Main Free-flow Product')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md4>
								<v-switch
									v-model="item.settings.is_preorder"
									:label="$t('Is Preorder')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md4>
								<v-switch
									v-model="
										item.settings
											.is_eligible_for_welcome_gift
									"
									:label="$t('Is Eligible for Welcome Gift')"
								></v-switch>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>

			<!-- schedule setting -->
			<v-flex xs12 v-if="item.schedule">
				<v-card
					><v-system-bar color="grey darken-4" height="10">
					</v-system-bar>
					<v-card-title primary-title>
						{{ $t("Schedule Setting") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<schedule-component
							v-model="item.schedule"
						></schedule-component>
					</v-card-text>
				</v-card>
			</v-flex>
			<!-- end schedule setting -->
		</v-layout>
	</v-container>
</template>

<script>
import ShopVariationForm from "./ShopVariationForm.vue";
import ShopExtraForm from "./ShopExtraForm.vue";
import ScheduleComponent from "@Shop/components/ScheduleComponent";
import { Inertia } from "@inertiajs/inertia";
export default {
	components: {
		ShopVariationForm,
		ShopExtraForm,
		ScheduleComponent,
	},
	props: [
		"value",
		"categories",
		"subcategories",
		"units",
		"taxes",
		"parents",
	],
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},

	methods: {
		onCategoryChanged() {
			Inertia.reload({
				only: ["subcategories"],
				data: {
					category_id: this.item.category_id,
				},
			});
		},
	},
};
</script>